<template>
  <div style="padding:5px 0">
    <div class="section operations">
      <div class="triggers">
        <div>
          <el-button v-show="$checkPermission(['button_TabCRMCustomerContact_add'])" :disabled="!isEditing" type="primary" no="1" @click="showEditDialog(1)">{{ $t('common.btn.add') }}</el-button>
          <el-button v-show="$checkPermission(['button_TabCRMCustomerContact_edit'])" :disabled="!(isEditing && selectedRow)" type="primary" no="2" @click="showEditDialog(2)">{{ $t('common.btn.edit') }}</el-button>
          <el-button v-show="$checkPermission(['button_TabCRMCustomerContact_delete'])" :disabled="!(isEditing && selectedRow)" size="mini" type="danger" no="3" @click="remove">{{ $t('common.btn.delete') }}</el-button>
        </div>
      </div>
    </div>
    <div class="section" style="flex: 1">
      <cargo-ag-grid
        config-module="23150201"
        :grid-params.sync="girdParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="finalRowData"
        no="4"
        @gridReady="params=>{gridApi=params.api}"
      />
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-if="editDialog.visible"
      id="editDialog"
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="$t('CargoMsg.Cargo_Contact')"
      width="400px"
      :close-on-click-modal="false"
      append-to-body
      no="5"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="105px" label-position="right">
          <el-form-item :label="$t('CargoMsg.Cargo_Contact')" required>
            <el-input v-model="editDialog.form.name" :disabled="!editDialog.isEdit" no="6" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_Tel')" required>
            <el-input v-model="editDialog.form.phone" :disabled="!editDialog.isEdit" no="7" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_MobilePhoneNo')">
            <el-input v-model="editDialog.form.cellphone" :disabled="!editDialog.isEdit" no="8" />
          </el-form-item>
          <el-form-item label="QQ">
            <el-input v-model="editDialog.form.qqAccout" :disabled="!editDialog.isEdit" no="9" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_WechatAccount')">
            <el-input v-model="editDialog.form.wechatAccout" :disabled="!editDialog.isEdit" no="10" />
          </el-form-item>
          <el-form-item label="Skype">
            <el-input v-model="editDialog.form.skypeAccout" :disabled="!editDialog.isEdit" no="11" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_email')">
            <el-input v-model="editDialog.form.email" :disabled="!editDialog.isEdit" no="12" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_Remarks')">
            <el-input v-model="editDialog.form.remarks" :disabled="!editDialog.isEdit" no="13" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Role')">
            <el-input v-model="editDialog.form.role" :disabled="!editDialog.isEdit" no="role" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_DefaultOrNot')">
            <el-radio-group v-model="editDialog.form.defaultContact" :disabled="!editDialog.isEdit" no="defaultContact" @change="onDefaultChange">
              <el-radio no="yes" :label="true">{{ $t('Message.Yes') }}</el-radio>
              <el-radio no="no" :label="false">{{ $t('Message.No') }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button v-show="editDialog.isEdit" type="primary" no="14" @click="save">{{ $t('common.btn.ok') }}</el-button>
        <el-button no="15" @click="close">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import { QuotationClient } from '@/class/model/sales/QuotationClient'
import { getLoading } from '@/utils/utilBaseElement'
import { AutoIncrementNum, ensureExecuteSuccess, sleep } from '@/utils/commonUtil'
import { TabError } from '@/utils/class/TabError'

export default {
  name: 'TabCrmCustomerContact',
  components: {
  },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      girdParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowClicked: this.onRowClicked,
        onRowDoubleClicked: event => { this.showEditDialog(0) }
      },
      columnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_Contact'),
          colId: 'name',
          field: 'name',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_Tel'),
          colId: 'phone',
          field: 'phone',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_MobilePhoneNo'),
          colId: 'cellphone',
          field: 'cellphone',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.CargoMsg_QQ'),
          colId: 'qqAccout',
          field: 'qqAccout',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_Wechat'),
          colId: 'wechatAccout',
          field: 'wechatAccout',
          width: 150
        }, {
          headerName: 'Skype',
          colId: 'skypeAccout',
          field: 'skypeAccout',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_email'),
          colId: 'email',
          field: 'email',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_Remarks'),
          colId: 'remarks',
          field: 'remarks',
          width: 150
        }, {
          headerName: this.$t('SeaExport.Role'),
          field: 'role',
          width: 100
        }, {
          headerName: this.$t('Partners.isDefault'),
          field: 'defaultContact',
          colId: 'defaultContact',
          initialWidth: 110,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            tag: 'el-checkbox',
            attrs: {
              isEditCBFunc: (params) => {
                return this.isEditing
              }
            },
            valueChanged: p => {
              this.changeDefaultHandler(p)
            }
          }
        }
      ],
      gridApi: null,
      rowData: [],
      selectedRow: null, // 当前选中行
      editDialog: {
        isEdit: false, // 是否编辑状态
        visible: false,
        form: {},
        initialForm: {
          uuid: '',
          name: '',
          phone: '',
          cellphone: '',
          qqAccout: '',
          wechatAccout: '',
          skypeAccout: '',
          email: '',
          remarks: '',
          type: '',
          role: '',
          defaultContact: false
        }
      },
      quotationClient: new QuotationClient().fillDefaultValue().getData(),
      autoIncrementNum: new AutoIncrementNum()
    }
  },
  computed: {
    isEditing() {
      return this.action !== 'look'
    },
    finalRowData() {
      return this.rowData.filter(p => !p.deleted)
    }
  },
  created() {
    this.editDialog.form = { ...this.editDialog.initialForm }
  },
  methods: {
    async onShow(row, isRefresh) {
      if (!isRefresh && this.isEditing) return
      this.quotationClient = { ...row }
      this.loading = getLoading()
      if (this.gridApi) {
        await sleep(100)
      } else {
        // 等待gridApi被赋值
        await ensureExecuteSuccess(() => this.gridApi)
      }
      this.selectedRow = null
      this.gridApi.clearFocusedCell()
      if (!this.isEditing || !this.quotationClient.quotationClientContact || this.quotationClient.quotationClientContact.length <= 0) {
        this.quotationClient.quotationClientContact = []
        await new QuotationClient(this.quotationClient).loadQuotationClientRelated({ contact: true })
        // this.$logger.log('this.quotationClient==========1', row, row.quotationClientContact)
      }
      for (const item of this.quotationClient.quotationClientContact) {
        item.seq = this.autoIncrementNum.getNextNum()
      }
      this.rowData = this.quotationClient.quotationClientContact
      // this.$logger.log('this.quotationClient==========2', this.quotationClient, this.rowData)
      this.loading.close()
    },
    onDefaultChange() {
      const form = this.editDialog.form
      if (form.defaultContact) {
        const existItem = this.finalRowData.find(p => p.defaultContact && p.seq !== form.seq)
        if (existItem) {
          this.$message.warning(this.$t('Partners.alreadyDefaultContact'))
        }
      }
    },
    // 保存
    getSubmitData() {
      this.validateForm()
      return {
        quotationClientContact: this.rowData
      }
    },
    // 校验
    validateForm() {
      const quotationClientContact = this.rowData
      if (!quotationClientContact || quotationClientContact.length < 1) {
        throw new TabError(this.$t('CargoMsg.Cargo_ContactPersonToFillInA'), 'tabCrmCustomerContact')
      }
      let allDeleted = 0
      for (const contact of quotationClientContact) {
        if (contact.deleted) allDeleted++
        if (!contact.name || !contact.phone) {
          throw new TabError(this.$t('CargoMsg.Cargo_CNATCBE'), 'tabCrmCustomerContact')
        }
      }
      if (allDeleted === quotationClientContact.length) {
        throw new TabError(this.$t('CargoMsg.Cargo_ContactPersonToFillInA'), 'tabCrmCustomerContact')
      }
      const defaultContacts = quotationClientContact.filter(p => p.defaultContact)
      if (defaultContacts && defaultContacts.length > 1) {
        throw new TabError(this.$t('Partners.notSaveTwoDefaultContact'), 'tabCrmCustomerContact')
      }
    },
    // 行点击
    onRowClicked(event) {
      if (!event || !event.data) return
      this.selectedRow = event.data
    },
    // 新增 1 /编辑 2/查看 0
    showEditDialog(state) {
      this.editDialog.isEdit = state !== 0
      if (state === 1) {
        this.editDialog.form = {
          seq: this.autoIncrementNum.getNextNum(),
          ...this.editDialog.initialForm
        }
      } else {
        if (!this.gridApi) return
        // 编辑 查看 走这里
        if (!this.selectedRow) {
          this.$message.warning(this.$t('CargoMsg.Cargo_NCS'))
          return
        }
        this.editDialog.form = this.selectedRow
      }
      this.editDialog.visible = true
    },
    // 确认保存/修改
    save() {
      const form = this.editDialog.form
      if (!form.name) {
        this.$message.warning('请填写联系人！')
        return
      }
      if (!form.phone) {
        this.$message.warning(this.$t('Message.PleaseInTheTelephoneNumber'))
        return
      }
      // 判断是否要设置为默认联系人
      if (form.defaultContact) {
        const existItem = this.finalRowData.find(p => p.defaultContact && p.seq !== form.seq)
        if (existItem) {
          existItem.defaultContact = false
          existItem.updated = true
        }
      } else {
        const existItem = this.finalRowData.find(p => !!p.defaultContact)
        if (!existItem) {
          form.defaultContact = true
        }
      }
      const row = this.rowData.find(item => item.seq === form.seq)
      if (row) {
        Object.assign(row, form)
        row.updated = true
      } else {
        this.rowData.push(form)
      }
      this.close()
      this.gridApi.refreshCells({ force: true })
    },
    // 取消
    close() {
      this.editDialog.visible = false
    },
    // 删除【只删除界面值】
    remove() {
      if (!this.selectedRow) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.$confirm(this.$t('common.tips.confirmDelete'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        if (this.selectedRow.uuid) { // 数据库里面存在的需要打个标识，数据库不存在的直接移除
          this.selectedRow.deleted = true // deleted 是否需要更新标识
          const tempRowData = this.rowData
          this.rowData = []
          this.$nextTick(() => {
            this.rowData = tempRowData
          })
        } else {
          const index = this.rowData.findIndex(p => p === this.selectedRow)
          if (index > -1) {
            this.rowData.splice(index, 1)
          }
        }
        setTimeout(() => {
          this.gridApi.setFocusedCell(0)
          this.selectedRow = null
          if (this.finalRowData && this.finalRowData.length > 0) {
            this.selectedRow = this.finalRowData[0]
          }
        }, 100)
        this.gridApi.refreshCells({ force: true })
      }).catch(() => { })
    },
    changeDefaultHandler(p) {
      const data = p.data
      if (data.defaultContact) {
        const existItem = this.finalRowData.find(p => p.defaultContact && p.seq !== data.seq)
        if (existItem) {
          existItem.defaultContact = false
          existItem.updated = true
        }
      } else {
        const existItem = this.finalRowData.find(p => !!p.defaultContact)
        if (!existItem) {
          data.defaultContact = true
        }
      }
      data.updated = true
    }
  }
}
</script>
<style scoped lang="scss">
#editDialog .app-main-inner-row ::v-deep {
  .el-form-item__label {
    font-size: 12px;
    font-weight: normal;
  }
}
</style>
